var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1376",
    "data-name": "Group 1376",
    transform: "translate(-48 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_145",
    "data-name": "Rectangle 145",
    width: 24,
    height: 24,
    transform: "translate(48 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1381",
    "data-name": "Group 1381",
    transform: "translate(51 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    d: "M11.334,8a3.334,3.334,0,1,0,2.358.976A3.335,3.335,0,0,0,11.334,8Zm0,5a1.667,1.667,0,1,1,1.179-.488A1.667,1.667,0,0,1,11.334,13Z",
    transform: "translate(-2.334 -1.333)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    d: "M17.951,11.583l-.37-.213a7.581,7.581,0,0,0,0-2.742l.37-.213a2.5,2.5,0,0,0-2.5-4.333l-.371.214A7.483,7.483,0,0,0,12.7,2.928V2.5a2.5,2.5,0,0,0-5,0v.428A7.484,7.484,0,0,0,5.329,4.3l-.373-.216a2.5,2.5,0,1,0-2.5,4.333l.37.213a7.581,7.581,0,0,0,0,2.742l-.37.213a2.5,2.5,0,0,0,2.5,4.333l.371-.214A7.483,7.483,0,0,0,7.7,17.073V17.5a2.5,2.5,0,0,0,5,0v-.428A7.483,7.483,0,0,0,15.078,15.7l.373.215a2.5,2.5,0,1,0,2.5-4.333ZM15.827,8.437a5.871,5.871,0,0,1,0,3.125.833.833,0,0,0,.387.944l.9.522a.834.834,0,0,1-.834,1.444l-.905-.523a.834.834,0,0,0-1.013.138,5.821,5.821,0,0,1-2.7,1.563.833.833,0,0,0-.626.808V17.5a.834.834,0,0,1-1.667,0V16.457a.833.833,0,0,0-.626-.808,5.822,5.822,0,0,1-2.7-1.566.834.834,0,0,0-1.013-.137l-.9.523a.833.833,0,1,1-.834-1.443l.9-.522a.833.833,0,0,0,.387-.944,5.872,5.872,0,0,1,0-3.125.833.833,0,0,0-.388-.941l-.9-.522a.834.834,0,0,1,.834-1.444l.905.523A.834.834,0,0,0,6.04,5.917a5.822,5.822,0,0,1,2.7-1.563.833.833,0,0,0,.626-.811V2.5a.834.834,0,0,1,1.667,0V3.543a.833.833,0,0,0,.626.808,5.822,5.822,0,0,1,2.7,1.566.834.834,0,0,0,1.013.138l.9-.523a.833.833,0,1,1,.834,1.443l-.9.522a.833.833,0,0,0-.386.941Z",
    transform: "translate(-1.203 0)",
    fill: "#15345a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingIcon);
export default __webpack_public_path__ + "static/media/settingIcon.cd2c4145740596ba32a60528823e3a2b.svg";
export { ForwardRef as ReactComponent };